<template>
  <b-tab title="Trendyol Ürünleri">
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button variant="info" size="sm" @click="tyMatching(product.id )">TY SKU Ekle</b-button>
      </b-col>
    </b-row>
    <b-row class="border">
      <b-col cols="2">
        id
      </b-col>
      <b-col cols="2">
        Durum
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        Ty Sku
      </b-col>
    </b-row>
    <b-row v-for="tyProduct in tyProducts" :key="tyProduct.id" class="border">
      <b-col cols="2">
        {{ tyProduct.id }} <a :href="'https://www.trendyol.com/w/w-w-p-'+tyProduct.productContentId" target="newTab">
        <feather-icon icon="HomeIcon"/>
      </a>

      </b-col>
      <b-col cols="2">
        <span v-if="tyProduct.pivot.status===0">Onay Bekliyor</span>
        <span v-if="[1,2].includes(tyProduct.pivot.status)">Onaylandı</span>
        <span v-if="[3,4].includes(tyProduct.pivot.status)">Red Edilmiş</span>
        <span v-if="tyProduct.pivot.status===5">Ertelenmiş</span>
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        {{ tyProduct.merchant_sku }}
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import addMpMatching from '@/mixins/addMpMatching'

export default {
  name: "StoreProductTab",
  mixins: [addMpMatching],
  props: {
    product: {
      type: Object,
      required: true,
    },
    tyProducts: {
      type: Array,
      required: true
    }
  }
}
</script>